module.exports = __webpack_public_path__ + "static/2-21f0d15bd6aeec2876e1275b81b231ca.png";